import { PatientExternalIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { Message, MessageType } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

const PatientOverTwelveMonthsAgeStatus = (): JSX.Element => {
   return (
      <Message
         testId={'status'}
         type={MessageType.WARNING}
         label={translationKeys.patientOverTwelveMonthsAgeCannotIdentifyWithGuardianPesel}
         fullWidth
         displayIndicator
      />
   );
};

type PatientExternalIdentifierTypeStillValidAgeMonitProps = {
   readonly patientExternalIdentifier: PatientExternalIdentifier | undefined;
};

export const PatientExternalIdentifierTypeStillValidAgeMonit = (
   props: PatientExternalIdentifierTypeStillValidAgeMonitProps
): JSX.Element | null => {
   return (
      props.patientExternalIdentifier?.accept<JSX.Element | null>({
         visitPesel: () => null,
         visitGuardianPesel: PatientOverTwelveMonthsAgeStatus,
         visitPassport: () => null,
         visitNationalIdentificationNumber: () => null,
      }) ?? null
   );
};
